module.exports = __webpack_public_path__ + "static/vr_background-050c882a4391cca2e24f1af83507c5ac.mp4";